import { Fragment, MutableRefObject } from "react";
import { Gallery, Item } from "react-photoswipe-gallery";
import { Link } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { H4, P } from "../../../../AbstractElements";
import { Href, ImageAbout, PortfolioTitle } from "../../../../Constants/Constants";
import { dynamicImage, dynamicNumber } from "../../../../Utils";
import PagesSort from "./Pages";

const PhotosTab = () => {
  return (
    <Fragment>
      <H4 className="mb-2">{ImageAbout}</H4>
      <Row className="my-gallery gallery-with-description">
        <Row>
          <Gallery withCaption>
            {dynamicNumber(4).map((item, i) =>
              dynamicNumber(4).map((item, i) => (
                <Col xl="3" sm="6" key={i}>
                  <figure itemProp="caption description">
                    <Item original={dynamicImage(`lightgallry/0${item}.jpg`)} caption="Using a camera's lens to record moments in time is the art form known as photography. To produce aesthetically striking photos, it entails the deft use of light, composition, and subject matter." width="802" height="476">
                      {({ ref, open }) => (
                        <Link to={Href} onClick={open}>
                          <img className="img-thumbnail border-bottom-0 p-2 rounded-0 rounded-top-1" ref={ref as unknown as MutableRefObject<HTMLImageElement>} src={dynamicImage(`lightgallry/0${item}.jpg`)} alt="Image_description" />
                          <div className="caption border-top-0 p-2">
                            <H4>{PortfolioTitle}</H4>
                            <P>{"Using a camera's lens to record moments in time is the art form known as photography. To produce aesthetically striking photos, it entails the deft use of light, composition, and subject matter."}</P>
                          </div>
                        </Link>
                      )}
                    </Item>
                  </figure>
                </Col>
              ))
            )}
          </Gallery>
        </Row>
      </Row>
      <PagesSort pageClass="start" />
    </Fragment>
  );
};

export default PhotosTab;
